export default [
  {
    title: '规则ID',
    key: 'id',
    width: 54
  },
  {
    title: '开关',
    key: 'state',
    width: 50
  },
  {
    title: '规则名称',
    key: 'name',
    width: 152
  },
  {
    title: '触发条件',
    key: 'monitorConditionDesc',
    width: 180
  },
  {
    title: '规则类型',
    key: 'ruleType',
    width: 120
  },
  {
    title: '范围类型',
    key: 'rangeTypeText',
    width: 90
  },
  {
    title: '监控频率',
    key: 'monitorTime'
  },

  {
    title: '游戏',
    key: 'gameInfo',
    width: 220,
    overflow: true
  },
  {
    title: '计划数',
    key: 'planCount',
    width: 64,
    align: 'center'
  },
  {
    title: '账号数',
    key: 'accountCount',
    width: 64,
    align: 'center'
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: 64
  },
  {
    title: '创建人',
    key: 'opName',
    width: 78
  },
  {
    title: '最后操作人',
    key: 'upOpName',
    width: 78
  },
  {
    title: '更新时间',
    key: 'updateTime',
    width: 114
  },
  {
    title: '最后暂停/启动时间',
    key: 'lastTime',
    width: 118
  },
  {
    title: '操作',
    key: 'control',
    width: 114
  }
]
